/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

if ($('.thumbs-box > ul > li').size() > 1) { // if slideshow has more than one slide, initialize slideshow
    var changeSlide = setInterval(function () {
        switchImage();
    }, 6000);
}

$('.thumbs-box > ul > li').click(function () {

    clearInterval(changeSlide);
    switchImage(0, $(this));

});

$('.thumbs-box > ul > li:last-child').addClass('last-child');

function switchImage(clicked, clickedThumb) {
    var current = $('.thumbs-box > ul > li.active'),
        next,
        slide,
        last = $('.thumbs-box > ul > li:last-child');

    if (last.index() === 1) {
        return;
    }

    if (clicked !== 0) {
        if (current.index() === last.index()) {
            next = $('.thumbs-box > ul > li:first-child');
        } else {
            next = current.next();
        }
    } else {
        next = clickedThumb;
    }

    slide = next.index();

    current.removeClass('active');
    next.addClass('active');

    $('.image-box > ul > li').removeClass('active');
    $('.image-box > ul > li').eq(slide).addClass('active');

}